import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import React from "react";
import {
  completeDocumentStep,
  setStepDocumentsEdited,
} from "../../../../../../store/redux/slice/Forms/seRecognitionForm";
import DocumentsForm from "../../../common/form/document/DocumentsForm";
import { baseEndpointPaths } from "../../../../../../services/serviceCalls";
import useFormReset from "../../../../../../hooks/useFormReset";
import useStepDocuments from "../../../../../../hooks/useStepDocuments";
import { fileGroups } from "../../../../../../config/fileGroupConfig";
import { ApplicationSubtype, ApplicationType } from "@duosoftbg/nacid-components";
import { Box } from "@mui/material";

const SERecognitionStepDocuments = () => {
  const seRecognitionForm = useAppSelector((state) => {
    return state.Forms.SERecognitionForm;
  });

  const { methods, onSubmit } = useStepDocuments(
    seRecognitionForm,
    baseEndpointPaths.seRecognition,
    completeDocumentStep,
    setStepDocumentsEdited,
  );

  useFormReset(ApplicationSubtype.SE_RECOGNITION, seRecognitionForm.documentDetails, methods.reset);

  return (
    <DocumentsForm
      methods={methods}
      onSubmit={onSubmit}
      setDocumentsFormEdited={setStepDocumentsEdited}
      hasAttachmentForm={true}
      hasAttachmentType={true}
      applicationId={seRecognitionForm.id}
      fileGroup={fileGroups.pdf}
      informingMessageCode={["m.rudi.files.info", "m.seServices.applications.info"]}
      applicationType={ApplicationType.SE_RECOGNITION}
      applicationSubType={ApplicationSubtype.SE_RECOGNITION}
    />
  );
};
export default SERecognitionStepDocuments;
